import { FC, useEffect } from 'react';
import { popularCollectionStore } from '@modules/collections/adapter/outbound/stores/popularCollection.store';
import { PopularCollectionLayout } from '@components/collection/popularCollection';
const PopularCollectionProvider: FC = () => {
  const {
    popularCollectionList,
    setPopularCollectionList
  } = popularCollectionStore(state => state);
  useEffect(() => {
    setPopularCollectionList();
  }, []);
  return <PopularCollectionLayout collectionList={popularCollectionList} />;
};
export default PopularCollectionProvider;